import { render } from "./SeedWord.vue?vue&type=template&id=0b0aa5c0&scoped=true"
import script from "./SeedWord.vue?vue&type=script&lang=js"
export * from "./SeedWord.vue?vue&type=script&lang=js"

import "./SeedWord.vue?vue&type=style&index=0&id=0b0aa5c0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0aa5c0"]])

export default __exports__